import { useState } from 'react'

import {
  EMPTY_STRING,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { useFloatingSelect } from '../../../hooks'
import { FloatingSelectDropdown } from '../../Floating'

import { BIRDVIEW_CHART_CATALOG_ALL_TAB } from './BirdviewChartCatalog.constants'
import {
  getBirdviewChartCatalogActiveTab,
  getBirdviewChartCatalogGroups,
  getBirdviewChartCatalogTabs,
} from './BirdviewChartCatalog.utils'
import { BirdviewChartCatalogButton } from './BirdviewChartCatalogButton'
import { BirdviewChartCatalogFooter } from './BirdviewChartCatalogFooter'
import { BirdviewChartCatalogHeader } from './BirdviewChartCatalogHeader'
import { BirdviewChartCatalogList } from './BirdviewChartCatalogList'

import * as styles from './BirdviewChartCatalog.module.css'

function BirdviewChartCatalog({
  Trigger = BirdviewChartCatalogButton,
  placement = FLOATING_ELEMENT_PLACEMENT.bottomStart,
  rows,
  shownCount,
  totalCount,
  onReset,
  onToggle,
}) {
  const [search, setSearch] = useState(EMPTY_STRING)
  const [tab, setTab] = useState(BIRDVIEW_CHART_CATALOG_ALL_TAB)

  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({ placement })

  const { setReference } = refs

  const activeTab = getBirdviewChartCatalogActiveTab({ rows, tab })

  function handleClickTrigger() {
    setOpen(prevIsOpen => !prevIsOpen)
  }

  return (
    <>
      <Trigger
        anchorRef={setReference}
        isOpen={isOpen}
        onClick={handleClickTrigger}
      />
      <FloatingSelectDropdown
        className={styles.dropdown}
        context={context}
        floatingStyles={floatingStyles}
        getFloatingProps={getFloatingProps}
        isOpen={isOpen}
        refs={refs}
      >
        <BirdviewChartCatalogHeader
          activeTab={activeTab}
          search={search}
          tabs={getBirdviewChartCatalogTabs(rows)}
          onChangeSearch={setSearch}
          onSelectTab={setTab}
        />
        <BirdviewChartCatalogList
          groups={getBirdviewChartCatalogGroups({
            rows,
            search,
            tab: activeTab,
          })}
          search={search}
          onToggle={onToggle}
        />
        <BirdviewChartCatalogFooter
          shownCount={shownCount}
          totalCount={totalCount}
          onReset={onReset}
        />
      </FloatingSelectDropdown>
    </>
  )
}

export default BirdviewChartCatalog
